//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    sourceData: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array | Object,
      default: function _default() {
        return [];
      }
    },
    branch: {
      type: Boolean,
      default: false
    }
  },
  inject: ['handlerAddNode']
};